/** Zoom à partir duquel les mailles se subdivisent : résolution 9 (~10 ha), puis 10 (~1,5 ha). */
export const FINE_ZOOM = 12;
export const FINER_ZOOM = 14;

/** Plafond de précision : pour revenir à la maille unique de 70 ha voulue par la spec, mettre 8. */
export const MAX_RESOLUTION = 10;

export function resolutionForZoom(zoom: number): 9 | 10 | null {
  const res = zoom >= FINER_ZOOM ? 10 : zoom >= FINE_ZOOM ? 9 : null;
  if (res == null || MAX_RESOLUTION < 9) return null;
  return Math.min(res, MAX_RESOLUTION) as 9 | 10;
}
